{
  "version": 1,
  "asset_id": "36cf2c25-1f7b-4db6-81a0-c2ada790a998",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/36cf2c25-1f7b-4db6-81a0-c2ada790a998/sleeve-hiatal-type-1-second-en-1254.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/36cf2c25-1f7b-4db6-81a0-c2ada790a998/sleeve-hiatal-type-1-second-en-1254.webp",
  "original_filename": "sleeve-hiatal-type-1-second-en-1254.webp",
  "size": 76564,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:31:52Z"
}
